var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: function ($event) {
        _vm.clickCopy(_vm.$t("查询"));
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("mavon-editor", {
    ref: "md",
    attrs: {
      subfield: false,
      defaultOpen: "edit"
    },
    on: {
      change: _vm.change
    },
    model: {
      value: _vm.content,
      callback: function ($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  }), _c("mavon-editor", {
    staticClass: "md",
    staticStyle: {
      "min-height": "20px"
    },
    attrs: {
      value: _vm.value,
      subfield: false,
      defaultOpen: "preview",
      toolbarsFlag: false,
      editable: false,
      scrollStyle: true,
      ishljs: true,
      boxShadow: false,
      previewBackground: "#fffff"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };